import {APIClient} from '../utils/APIClient';
import {API_URL} from '../settings/local_settings';

// Escalafy como CANAL (tanda 2026-10-01, contrato §2, §3 y §5): lo que sumó la conexión genérica. El OAuth de
// la agencia y los vínculos de la pantalla de economía siguen en `clientEconomicsApi.js`, que no cambia.
const PORTAL_BASE = `${API_URL}portal/me/connections/escalafy/`;

function withClient(body, agencyClientId) {
    return agencyClientId ? {...body, agency_client_id: agencyClientId} : body;
}

export const EscalafyChannelApi = {
    /** La pantalla de Conexiones de la agencia: trae `escalafy_credentials` y `channels_allowed` (§2). */
    agencyConnections() {
        return new APIClient(`${API_URL}agency/connections/`).call('GET');
    },

    /** Renombrar una conexión, con el id de la credencial GENÉRICA (`id`, no `credential_id`). */
    renameCredential(agencyChannelCredentialId, label) {
        return new APIClient(`${API_URL}agency/credentials/ESCALAFY/${encodeURIComponent(agencyChannelCredentialId)}/`)
            .call('PATCH', {label});
    },

    // --- Portal del cliente (§5) -----------------------------------------------------------------

    portalAuthUrl(redirectUri, agencyClientId = null) {
        const params = new URLSearchParams({redirect_uri: redirectUri});
        if (agencyClientId) params.set('agency_client_id', String(agencyClientId));
        return new APIClient(`${PORTAL_BASE}auth-url/?${params.toString()}`).call('GET');
    },

    portalCallback({code, state, redirectUri, agencyClientId = null}) {
        return new APIClient(`${PORTAL_BASE}callback/`)
            .call('POST', withClient({code, state, redirect_uri: redirectUri}, agencyClientId));
    },

    portalSelect({credentialId, orgId, agencyClientId = null}) {
        return new APIClient(`${PORTAL_BASE}select/`)
            .call('POST', withClient({credential_id: credentialId, org_id: orgId}, agencyClientId));
    },
};

/**
 * El cuerpo útil de una respuesta del portal: sus vistas responden las claves sueltas junto al `status`
 * (`{status, connections}`), y las de agencia dentro de `data`. Acepta las dos formas.
 */
export function payloadOf(response) {
    if (!response || response.status !== 'OK') return null;
    const data = response.data;
    if (data && typeof data === 'object' && !Array.isArray(data)) return data;
    return response;
}

export default EscalafyChannelApi;
